import { css } from 'aphrodite';
import { PieChart, Pie, Sector, Cell } from 'recharts';
import * as React from 'react';
import Department from 'src/models/Department.js';
import { getRandomColor } from 'src/views/Utils';
import { getDepartmentStats } from 'src/core/api';
import { Card, CardHeader } from 'reactstrap';
import {styles} from "src/styles/CollegePage";
import ListGroup from 'reactstrap/lib/ListGroup';
import ListGroupItem from 'reactstrap/lib/ListGroupItem';

interface ICollegePageProps {
    history: any
}

class DepartmentItem {

    public readonly id : number;
    public readonly name: string;
    public readonly count: number
    public readonly color: any

    constructor(id: number,name: string,count: number, color: any) {
        this.id = id
        this.name = name
        this.count = count
        this.color = color
    }
}

class CollegePageState {
    public readonly data : DepartmentItem[]
    public readonly activeIndex: number
    
    constructor(){
        this.data = getDepartmentStats().map((department: Department) => {
            return new DepartmentItem(
                department.id,
                department.name,
                department.count,
                getRandomColor()
            )
        });
        this.activeIndex = 0
    }
}


class CollegePage extends React.Component<ICollegePageProps,CollegePageState> {

    constructor(props: ICollegePageProps) {
        super(props)
        this.state = new CollegePageState();
    }

    public render() {
        return (
            <div id="content" className={css(styles.content)} >
                
                <h4 id="title" className={css(styles.title)}>
                    Distribution of awards by department
                </h4>

                <div id="chart_container" className={css(styles.chart_container)} >
                    
                    <div className={css(styles.legendContainer)} >
                        <Card id="legend" className={css(styles.legendCard)} >
                            <CardHeader>
                                Total :  $ {this.getTotoal(this.state.data)}
                            </CardHeader>
                            <ListGroup flush={true} className={css(styles.legends)} >
                                    {
                                        this.state.data.map(this.renderLegendItem)
                                    }
                            </ListGroup>
                        </Card>     
                    </div>
                   
                    <PieChart 
                        width={1000}
                        height={550}
                        className={css(styles.chart)}
                        >
                        <Pie 
                            activeIndex={this.state.activeIndex}
                            activeShape={renderActiveShape} 
                            data={this.state.data} 
                            innerRadius={100}
                            outerRadius={180} 
                            fill="#8884d8"
                            label={renderLabel}
                            labelLine={false}
                            nameKey={"name"}
                            dataKey={"count"}
                            onMouseEnter={this.onPieEnter}
                            onClick={this.onPieClick}
                        >
                            {
                               this.state.data.map((entry, index) => <Cell fill={entry.color} key={index} />)
                            } 
                        </Pie>
                    </PieChart>

                </div>
                   
                                
            </div>
        )      
    }

    private getTotoal = (data: DepartmentItem[]) => {
        let total = 0;
        for (const department of data){
            total = total + department.count;
        }
        return total;
    }
    
    private onPieEnter = (data: any, index: number) => {
        this.setState({
            activeIndex: index,
        });
    }
    
    private onPieClick = (data: any, index: number) => {
        const department = this.state.data[index];
        console.log(department)
        this.props.history.push("/department/" + department.id);
    }

    private renderLegendItem = (department: DepartmentItem,index: number) => {
        return (
        <ListGroupItem >
            <div id="legend_item" className={css(styles.legendItem)}
                                      onMouseEnter={this.onLegendHover(index)}
                                      onClick={this.onLegendClick(index)} 
                                      key={index}>
                <div style={{
                    width: 30,
                    height: 30,
                    backgroundColor: department.color,
                    marginRight:10
                }}/>

                <div style={{
                    fontSize:16,
                    color:"gray"
                }}>
                    {department.name}
                </div>

            </div>
        </ListGroupItem>);
    }
    
    private onLegendHover = (index: number) => (event: any) => {
        console.log(index)
        this.setState({
            activeIndex: index
        })
    }

    private onLegendClick = (index: number) => (event: any) => {
        const department = this.state.data[index];
        this.props.history.push("/department/" + department.id);
    }
    

}

const renderLabel = (props: any) => {
    const RADIAN = Math.PI / 180;
    const { cx, cy, midAngle, outerRadius,
      fill, payload, percent } = props;
    const sin = Math.sin(-RADIAN * midAngle);
    const cos = Math.cos(-RADIAN * midAngle);
    const sx = cx + (outerRadius + 10) * cos;
    const sy = cy + (outerRadius + 10) * sin;
    const mx = cx + (outerRadius + 50) * cos;
    const my = cy + (outerRadius + 60) * sin;
    const ex = mx + (cos >= 0 ? 1 : -1) * 22;
    const ey = my;
    const textAnchor = cos >= 0 ? 'start' : 'end';
  
    return (
      <g className={css(styles.hover)} >
        
        
        <path d={`M${sx},${sy}L${mx},${my}L${ex},${ey}`} stroke={fill} fill="none"/>
        <circle cx={ex} cy={ey} r={2} fill={fill} stroke="none"/>
        <text x={ex + (cos >= 0 ? 1 : -1) * 12} y={ey} textAnchor={textAnchor} fill="#333">{`${payload.name} (${(percent * 100).toFixed(2)}%)`}</text>
      </g>
    );
};
  

const renderActiveShape = (props: any) => {
    const RADIAN = Math.PI / 180;
    const { cx, cy, midAngle, innerRadius, outerRadius, startAngle, endAngle,
      fill, payload, percent } = props;
    const sin = Math.sin(-RADIAN * midAngle);
    const cos = Math.cos(-RADIAN * midAngle);
    const sx = cx + (outerRadius + 10) * cos;
    const sy = cy + (outerRadius + 10) * sin;
    const mx = cx + (outerRadius + 50) * cos;
    const my = cy + (outerRadius + 60) * sin;
    const ex = mx + (cos >= 0 ? 1 : -1) * 22;
    const ey = my;
    const textAnchor = cos >= 0 ? 'start' : 'end';
  
    return (
      <g className={css(styles.hover)} >
        <text x={cx} y={cy} dy={8} textAnchor="middle" fill={fill}>{payload.name}</text>
        <Sector
          cx={cx}
          cy={cy}
          innerRadius={innerRadius}
          outerRadius={outerRadius}
          startAngle={startAngle}
          endAngle={endAngle}
          fill={fill}
        />
        <Sector
          cx={cx}
          cy={cy}
          startAngle={startAngle}
          endAngle={endAngle}
          innerRadius={outerRadius + 6}
          outerRadius={outerRadius + 10}
          fill={fill}
        />
        <path d={`M${sx},${sy}L${mx},${my}L${ex},${ey}`} stroke={fill} fill="none"/>
        <circle cx={ex} cy={ey} r={2} fill={fill} stroke="none"/>
        <text x={ex + (cos >= 0 ? 1 : -1) * 12} y={ey} textAnchor={textAnchor} fill="#333">{`${payload.name} (${(percent * 100).toFixed(2)}%)`}</text>
      </g>
    );
};

export default CollegePage;


// WEBPACK FOOTER //
// ./src/pages/CollegePage.tsx